import Vue from 'vue';
import Vuex from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { moduleAuthData } from './modules/authData';
import { moduleNotifications } from './modules/notifications/notifications';
import { moduleScheduler } from './modules/scheduler';
import { moduleSocket } from './modules/socket/socket';
import { moduleStaticData } from './modules/staticData/staticData';
import { moduleUser } from './modules/user';
import { moduleQuantCart } from './modules/quantCart';
import { mutations } from './mutations';
import { state } from './state';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    moduleUser,
    moduleAuthData,
    moduleScheduler,
    moduleSocket,
    moduleNotifications,
    moduleStaticData,
    moduleQuantCart,
  },
  state,
  getters,
  mutations,
  actions,
});
